import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useI18N } from '../context/I18NContext';
import { useSettings } from '../context/SettingsContext';
import useWidgetStore from '../store/useWidgetStore';
export default function Consumer(props) {
    const { t } = useI18N();
    const [consumerName, setConsumerName] = useState();
    const { consumer } = useWidgetStore();
    const { hasAccounts } = useSettings();
    useEffect(() => {
        setConsumerName([consumer.firstName, consumer.insertions, consumer.lastName].join(' '));
    }, [consumer]);
    return (_jsx(_Fragment, {}));
}
